module.exports = __webpack_public_path__ + "static/media/location-maps-letter-l.09eebd45.png";